import React, { useContext } from 'react'
import HeaderResponsiveSearch from '../components/HeaderResponsiveSearch'
import { Settings } from '../contexts/Settings'
import { AuthContext } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

function Header() {
    const { clickMenu, openSearch, clickSearch, clickAvatar, profileSetting, screenWidth, mode, clickMode } = useContext(Settings);
    const { profile, logOut } = useContext(AuthContext);
    console.log(screenWidth)
    return (
        <>
            <header className="app-header sticky" id="header">
                {/* Start::main-header-container */}
                <div className="main-header-container container-fluid">
                    {/* Start::header-content-left */}
                    <div className="header-content-left">
                        {/* Start::header-element */}
                        <div className="header-element">
                            <div className="horizontal-logo">
                                <Link to="/" className="header-logo">
                                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="desktop-logo" />
                                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="toggle-logo" />
                                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="desktop-dark" />
                                    <img src="https://elnaf.fi/assets/img/logo/ElnafLogo.svg" alt="logo" className="toggle-dark" />
                                </Link>
                            </div>
                        </div>
                        {/* End::header-element */}
                        {/* Start::header-element */}
                        <div className="header-element">
                            {/* Start::header-link */}
                            <a aria-label="Hide Sidebar" className="sidemenu-toggle header-link" data-bs-toggle="sidebar" onClick={clickMenu}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="header-link-icon menu-btn" width={32} height={32} fill="#000000" viewBox="0 0 256 256">
                                    <path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z">
                                    </path>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" className="header-link-icon menu-btn-close" width={32} height={32} fill="#000000" viewBox="0 0 256 256">
                                    <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                                    </path>
                                </svg>
                            </a>
                            {/* End::header-link */}
                        </div>
                        {/* End::header-element */}
                    </div>
                    {/* End::header-content-left */}
                    {/* Start::header-content-right */}
                    <ul className="header-content-right">
                        {/* Start::header-element */}
                        <li className="header-element d-md-none d-block">
                            <a href="" className="header-link" data-bs-toggle="modal" data-bs-target="#header-responsive-search">
                                {/* Start::header-link-icon */}
                                <i className="bi bi-search header-link-icon" />
                                {/* End::header-link-icon */}
                            </a>
                        </li>
                        {/* End::header-element */}
                        {/* Start::header-element */}
                        <li className="header-element search-dropdown dropdown d-md-block d-none">
                            {/* Start::header-link|dropdown-toggle */}
                            <a href=" " onClick={clickSearch} className={`header-link dropdown-toggle ${openSearch ? 'show' : ''}`} data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded={openSearch}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="header-link-icon" width={32} height={32} fill="#000000" viewBox="0 0 256 256">
                                    <path d="M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z">
                                    </path>
                                </svg>
                            </a>
                            <ul className={`main-header-dropdown dropdown-menu dropdown-menu-end overflow-visible ${openSearch ? 'show' : ''}`} style={openSearch ? { position: 'absolute', inset: '0px 0px auto auto', margin: '0px', transform: 'translate3d(0px, 36px, 0px)' } : {}} data-popper-placement="none">
                                <li className="px-3 py-2">
                                    <div className="header-element header-search d-md-block d-none my-auto">
                                        {/* Start::header-link */}
                                        <input type="text" className="header-search-bar form-control" id="header-search" placeholder="Search for Results..." spellCheck="false" autoComplete="off" autoCapitalize="off" />
                                        <a href="" className="header-search-icon border-0">
                                            <i className="bi bi-search" />
                                        </a>
                                        {/* End::header-link */}
                                    </div>
                                </li>
                            </ul>
                        </li>
                        {/* End::header-element */}
                        {/* Start::header-element */}
                        {/* End::header-element */}
                        {/* Start::header-element */}
                        <li className="header-element header-theme-mode">
                            {/* Start::header-link|layout-setting */}
                            <button onClick={clickMode} style={{ border: 'none', background: 'none' }} className="header-link layout-setting">
                                <span className="light-layout">
                                    {/* Start::header-link-icon */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="header-link-icon" viewBox="0 0 256 256">
                                        <rect width={256} height={256} fill="none" />
                                        <path d="M108.11,28.11A96.09,96.09,0,0,0,227.89,147.89,96,96,0,1,1,108.11,28.11Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                    </svg>
                                    {/* End::header-link-icon */}
                                </span>
                                <span className="dark-layout">
                                    {/* Start::header-link-icon */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="header-link-icon" viewBox="0 0 256 256">
                                        <rect width={256} height={256} fill="none" />
                                        <line x1={128} y1={40} x2={128} y2={32} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <circle cx={128} cy={128} r={56} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={64} y1={64} x2={56} y2={56} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={64} y1={192} x2={56} y2={200} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={192} y1={64} x2={200} y2={56} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={192} y1={192} x2={200} y2={200} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={40} y1={128} x2={32} y2={128} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={128} y1={216} x2={128} y2={224} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                        <line x1={216} y1={128} x2={224} y2={128} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} />
                                    </svg>
                                    {/* End::header-link-icon */}
                                </span>
                            </button>
                            {/* End::header-link|layout-setting */}
                        </li>
                        {/* End::header-element */}
                        {/* Start::header-element */}
                        {/* End::header-element */}
                        {/* Start::header-element */}

                        {/* End::header-element */}
                        {/* Start::header-element */}

                        {/* End::header-element */}
                        {/* Start::header-element */}
                        <li className="header-element dropdown">
                            {/* Start::header-link|dropdown-toggle */}
                            <a href="" onClick={clickAvatar} className={`header-link dropdown-toggle ${profileSetting ? 'show' : ''}`} id="mainHeaderProfile" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded={profileSetting ? true : false}>
                                <div className="d-flex align-items-center">
                                    <div className="me-xl-2 me-0">
                                        <img src="/assets/images/faces/1.jpg" alt="img" className="avatar avatar-sm avatar-rounded" />
                                    </div>
                                    <div className="d-xl-block d-none lh-1">
                                        <span className="fw-medium lh-1">{profile.full_name || 'noName'}</span>
                                    </div>
                                </div>
                            </a>
                            {/* End::header-link|dropdown-toggle */}
                            <ul className={`main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end ${profileSetting ? 'show' : ''}`} aria-labelledby="mainHeaderProfile" style={profileSetting ? {
                                position: 'absolute',
                                inset: '0px 0px auto auto',
                                margin: '0px',
                                transform: `translate3d(0px, ${screenWidth > 576 ? 36 : 60.8}px, 0px)`,

                            } : null}>
                                <li>
                                    <div className="py-2 px-3 text-center"> <span className="fw-semibold"> {profile.full_name} </span> <span className="d-block fs-12 text-muted">{profile.position}</span> </div>
                                </li>
                                <li><Link className="dropdown-item d-flex align-items-center" to="/profile"><i className="ti ti-user text-primary me-2 fs-16" />Profile</Link>
                                </li>
                                <li className="py-2 px-3"><button className="btn btn-primary btn-sm w-100" onClick={logOut}>Log Out</button>
                                </li>
                            </ul>
                        </li>
                        {/* End::header-element */}
                        {/* Start::header-element */}

                        {/* End::header-element */}
                    </ul>
                    {/* End::header-content-right */}
                </div>
                {/* End::main-header-container */}
            </header>
            <HeaderResponsiveSearch />
        </>
    )
}

export default Header